import { inject, injectable } from "inversify";
import { ICPLCaseTypesClient, IntSelectModel, CaseTypeModel } from "./api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

export interface ICaseTypesService {
  getCaseTypes(): Promise<CaseTypeModel[]>;
  createCaseType(name: string, showOnPortal: boolean): Promise<void>;
  updateCaseType(caseTypeModel: CaseTypeModel): Promise<void>;
  deleteCaseType(caseTypeID: number): Promise<void>;
  getCaseTypeSelectModels(): Promise<IntSelectModel[]>;
}

@injectable()
export class CaseTypesService implements ICaseTypesService {
  @inject(SERVICE_TYPES.CPLCaseTypesClient) cplCaseTypesClient!: ICPLCaseTypesClient;

  async getCaseTypes(): Promise<CaseTypeModel[]> {
    return this.cplCaseTypesClient.getCaseTypes();
  }

  async createCaseType(name: string, showOnPortal: boolean): Promise<void> {
    return this.cplCaseTypesClient.createCaseType(name, showOnPortal);
  }

  async updateCaseType(caseTypeModel: CaseTypeModel): Promise<void> {
    return this.cplCaseTypesClient.updateCaseType(caseTypeModel);
  }

  async deleteCaseType(caseTypeID: number): Promise<void> {
    return this.cplCaseTypesClient.deleteCaseType(caseTypeID);
  }

  async getCaseTypeSelectModels(): Promise<IntSelectModel[]> {
    return this.cplCaseTypesClient.getCaseTypeSelectModels();
  }
}
